import React from 'react';
import Typography from '@material-ui/core/Typography';

export function StepFinishContent() {
  return (
    <Typography variant="body1">
      Nabídka změny provozovatele provozovny OVZ byla úspěšně odeslána.
    </Typography>
  );
}
